import React, { PropsWithChildren } from "react";

import CustomDropdownBase from "@src/sharedComponents/CustomDropdownBase/CustomDropdownBase";

import styles from "./Dropdown.module.css";

interface Props {
  curItemName: string;
  isDisabled: boolean;
  showDropdown: boolean;
  setShowDropdown: (b: boolean) => void;
  menuActionItems?: JSX.Element;
  isLoading?: boolean;
  width?: number;
}

const DropdownMenuWithIsFavorite: React.FC<PropsWithChildren<Props>> = ({
  curItemName,
  isDisabled,
  showDropdown,
  setShowDropdown,
  menuActionItems,
  isLoading,
  width,
  children,
}: PropsWithChildren<Props>): JSX.Element => {
  return (
    <CustomDropdownBase
      curItem={{ value: curItemName }}
      isDisabled={isDisabled}
      showDropdown={showDropdown}
      setShowDropdown={setShowDropdown}
      isLoading={isLoading}
      width={width}
    >
      <>
        {children}

        <div className={styles.actionItems}>{menuActionItems}</div>
      </>
    </CustomDropdownBase>
  );
};

export default DropdownMenuWithIsFavorite;
